import React, { useState, useContext, useEffect } from "react";
import ReportFrame from "./reports/report-frame";
import SessionContext from "SessionContext";

export default function Reports() {
  const session = useContext(SessionContext);
  const [pieReport, setPieReport] = useState(false);
  const [graphReport, setGraphReport] = useState(false);
  const [barReport, setBarReport] = useState(false);
  const [userDundasToken, setUserDundasToken] = useState();

  const showReport = (report) => {
    setPieReport(false);
    setGraphReport(false);
    setBarReport(false);
    switch (report) {
      case "pie":
        setPieReport(true);
        break;
      case "graph":
        setGraphReport(true);
        break;
      case "bar":
        setBarReport(true);
        break;

      default:
        break;
    }
  };

  // get dundas token
  useEffect(() => {
    const user_id = session.appState.identity.user.id;
    const timeToCheckToken = 30; // in minutes

    const checkIfTokenExist = () => {
      const tokenExpirationTime = sessionStorage.getItem("dundas-token-expiration");
      if(!tokenExpirationTime) {
        return false;
      }
      return true;
    };
    
    const checkIfTokenExpired = () => {
      var createdTime = new Date(parseInt(sessionStorage.getItem("dundas-token-expiration")));
      var thirtyMin = 1000 * 60 * timeToCheckToken; 
      var isExpired = (new Date().getTime() - createdTime < thirtyMin) ? false : true;
      return isExpired;
    };

    const getNewToken = () => {
      session.query("report/get", {id: user_id})
      .then((response) => {
       setUserDundasToken(response['data-logon-token-id']);
       sessionStorage.setItem("dundas-token-expiration", new Date().getTime());
      });
    };

    if(user_id) {
      if(checkIfTokenExist()) {
        if(checkIfTokenExpired()) {
          getNewToken();
        }
      } else {
        getNewToken();
      }

    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <h1>Reports</h1>
      </div>
      <div className="admin-links cards-wrapper">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Example Pie Chart Report</h5>
            <p className="card-text">An example embedded report.</p>
            <button onClick={() => showReport("pie")}>Open</button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Example Graph Chart Report</h5>
            <p className="card-text">An example embedded report.</p>
            <button onClick={() => showReport("graph")}>Open</button>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Example Bar Chart Report</h5>
            <p className="card-text">An example embedded report.</p>
            <button onClick={() => showReport("bar")}>Open</button>
          </div>
        </div>
      </div>
      <div className="report-section">
        {pieReport && (
          <div>
            <h3>Pie Chart</h3>
            <ReportFrame 
              shortlink="qk1gcqqhem8wpb48qbqzksunfw"
              token={userDundasToken}
            />
          </div>
        )}

        {graphReport && (
          <div>
            <h3>Graph Chart</h3>
            <ReportFrame 
              shortlink="cwsnchy3qskr7mujkueja8zgar"
              token={userDundasToken}
            />
          </div>
        )}

        {barReport && (
          <div>
            <h3>Bar Chart</h3>
            <ReportFrame 
              shortlink="75hr6uhh5h9wbqgtj76jgwpasa"
              token={userDundasToken}
            />
          </div>
        )}
      </div>
    </div>
  );
}
